import '../assets/Tooltip.css';
import { defineComponent, useCssVars, unref, ref, computed, openBlock, createBlock, Transition, withCtx, withDirectives, createElementVNode, normalizeStyle, createTextVNode, toDisplayString, vShow } from 'vue';
import { u as useElementSize } from './index.Cp00ESn6.js';
import { e as appendPx, o as useStore } from './useStore.DAPvMbcE.js';

const _hoisted_1 = ["data-to-left"];
const paddingX = 20;
const paddingY = 10;
const arrowH = 8;
const arrowX = 10;
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Tooltip",
  props: {
    autoHide: {},
    backColor: { default: "#88001e" },
    color: { default: "#ffffff" }
  },
  setup(__props, { expose: __expose }) {
    useCssVars((_ctx) => ({
      "5387a618": _ctx.backColor,
      "67a1059b": _ctx.color,
      "3e2da8a3": unref(appendPx)(paddingY),
      "3e2da884": unref(appendPx)(paddingX),
      "189ed2fc": unref(appendPx)(arrowX),
      "189ed10c": unref(appendPx)(arrowH)
    }));
    const store = useStore();
    const props = __props;
    const timer = ref();
    const rootRef = ref();
    const showing = ref(false);
    const message = ref();
    const position = ref();
    const { width, height } = useElementSize(rootRef);
    const toLeft = computed(() => {
      if (position.value && store?.styles.rootElement) {
        const {
          left: containerLeft,
          width: containerWidth
        } = store.styles.rootElement.getBoundingClientRect();
        return position.value.left > containerLeft + containerWidth / 2;
      }
      return false;
    });
    const rootStyle = computed(() => {
      if (position.value && rootRef.value) {
        const {
          left,
          top
        } = position.value;
        const arrowDistance = arrowX + arrowH;
        const totalHeight = height.value + paddingY * 2 + arrowH;
        const totalWidth = width.value + paddingX * 2;
        return {
          top: appendPx(top - totalHeight),
          left: appendPx(left - (toLeft.value ? totalWidth - arrowDistance : arrowDistance))
        };
      }
      return {};
    });
    function clearTimer() {
      if (timer.value) {
        clearTimeout(timer.value);
        timer.value = null;
      }
    }
    function hide() {
      clearTimer();
      showing.value = false;
    }
    function show(text, targetPosition) {
      clearTimer();
      showing.value = true;
      position.value = targetPosition;
      message.value = text;
      if (props.autoHide) {
        timer.value = setTimeout(() => {
          hide();
        }, props.autoHide);
      }
    }
    __expose({
      show,
      hide,
      showing
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(Transition, { name: "fade-tooltip" }, {
        default: withCtx(() => [
          withDirectives(createElementVNode("div", {
            class: "thn--tool-tooltip",
            ref_key: "rootRef",
            ref: rootRef,
            style: normalizeStyle(rootStyle.value)
          }, [
            createElementVNode("span", {
              class: "thn--tool-tooltip__arrow",
              "data-to-left": toLeft.value
            }, null, 8, _hoisted_1),
            createTextVNode(" " + toDisplayString(message.value), 1)
          ], 4), [
            [vShow, showing.value]
          ])
        ]),
        _: 1
      });
    };
  }
});

export { _sfc_main as _ };
//# sourceMappingURL=Tooltip.vue_vue_type_style_index_0_lang.DaDt-PuW.js.map
